import { render, staticRenderFns } from "./MomentPageLite.vue?vue&type=template&id=6b0d7fc9&"
import script from "./MomentPageLite.vue?vue&type=script&lang=js&"
export * from "./MomentPageLite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports